import React from 'react'
import { getBrandForHost } from '../../branding/brandConfig'
import { Link } from 'react-router-dom'
import { Facebook, Twitter, Instagram, Youtube, Mail, MapPin, Phone } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const brand = getBrandForHost(window.location.hostname)
  const credit = brand.footerCredit

  const footerLinks = {
    Platform: [
      { name: 'Calendar', path: '/calendar' },
      { name: 'Artists', path: '/artists' },
      { name: 'Marketplace', path: '/marketplace' },
      { name: 'Forums', path: '/forums' },
    ],
    Community: [
      { name: 'About Us', path: '/about' },
      { name: 'Contact', path: '/contact' },
      { name: 'Submit Event', path: '/submit-event' },
      { name: 'Advertise', path: '/advertise' },
    ],
    Support: [
      { name: 'Help Center', path: '/help' },
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Terms of Service', path: '/terms' },
      { name: 'Content Policy', path: '/content-policy' },
    ],
  }

  const socialLinks = [
    { name: 'Facebook', icon: Facebook, url: '#' },
    { name: 'Twitter', icon: Twitter, url: '#' },
    { name: 'Instagram', icon: Instagram, url: '#' },
    { name: 'YouTube', icon: Youtube, url: '#' },
  ]

  return (
    <footer className="bg-le-darker border-t border-white/10 mt-20">
      <div className="container-max section-padding py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-le-accent to-le-accent-2 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">LE</span>
              </div>
              <div>
                 <h3 className="font-display font-bold text-xl text-white">{brand.siteName}</h3>
                 <p className="text-white/60">{brand.tagline}</p>
              </div>
            </div>
            <p className="text-white/70 mb-6 max-w-md">
              Discover live music, connect with artists, buy and sell gear, and join Wichita's vibrant music community.
            </p>
            <div className="space-y-2 text-sm text-white/60">
              <div className="flex items-center space-x-2">
                <MapPin size={16} />
                <span>Wichita, Kansas</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <span>hello@littleeddieaudio.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} />
                <span>(316) 555-EDDIE</span>
              </div>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-semibold text-white mb-4">{category}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-white/60 hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-white/60 text-sm mb-4 md:mb-0">© {currentYear} {credit}</p>
          <div className="flex items-center space-x-4">
            {socialLinks.map((social) => {
              const Icon = social.icon
              return (
                <a
                  key={social.name}
                  href={social.url}
                  className="w-10 h-10 glass-card rounded-lg flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-all duration-200"
                  aria-label={social.name}
                >
                  <Icon size={18} />
                </a>
              )
            })}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer